import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-add-queue-dialog',
  templateUrl: './add-queue-dialog.component.html',
  styleUrls: ['./add-queue-dialog.component.scss']
})
export class AddQueueDialogComponent implements OnInit {
  name = '';
  existingNames: string[] = [];

  get isSaveDisabled() {
    return !this.name || this.existingNames.some((x) => x.toLowerCase() == this.name.toLowerCase());
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<AddQueueDialogComponent>) {
    this.existingNames = data.existingNames;
  }

  ngOnInit(): void {
  }

  save() {
    if (!this.isSaveDisabled) {
      this.dialogRef.close(this.name);
    }
  }

  close() {
    this.dialogRef.close();
  }
}
